<template>
  <div class="flyingBook">
    <img style="width: 50px" src="../../assets/images/loading.gif" alt="" />
  </div>
</template>

<script>
import { getLogo } from '@/utils/intConfiguration';
import {
  setAccount,
  setUserSys,
  setUserZnEnv,
  setToken,
  // eslint-disable-next-line import/extensions
} from '../login/login-handler.js';
import { getUiFitment } from '@/utils/accessResources';

const { envList } = require('../../../config/dev.proxy');

export default {
  components: {},
  data() {
    return {
      logoUi: getLogo(),
    };
  },
  computed: {},
  created() {
  },
  mounted() {
    this.init();
  },
  /**
   * 本页面旨在 飞书再次打开的中间页 对传过来的初始化缓存参数 进行存储
   * 01 线上缓存 _this.logoUi.appId 不需要从上级页面带入
   * 02 setToken(res) // 菜单缓存 需要res 从上级页面传入
   * 03 setAccount(res, loginRes) // 菜单缓存 需要res loginRes从上级页面传入
   * 04 进行页面跳转
   */
  methods: {
    init() {
      // eslint-disable-next-line camelcase
      // debugger
      // eslint-disable-next-line camelcase
      const res_data = JSON.parse(decodeURIComponent(this.$route.query.data));
      setToken(res_data.url_res);
      this.initenv();
      setAccount(res_data.url_login_res, res_data.url_res);
      getUiFitment().finally(()=>{
        this.$router.push({
        ...res_data.push,
        });
      })
    },
    // TODO线上缓存 （适配apaas+告警sdk apaas调整结构，统一网络库后 废弃）
    initenv() {
      // eslint-disable-next-line no-underscore-dangle
      const _this = this;
      function prdZnv() {
        // eslint-disable-next-line no-unused-vars
        let isProduct = true;
        envList.forEach((m) => {
          if (window.location.hostname.toString().includes(m)) {
            isProduct = false;
            setUserZnEnv(m);
            setUserSys(_this.logoUi.appId);
          }
        });
        if (isProduct) {
          setUserZnEnv('product');
          // 本地ng转发后 appId未定义问题
          // eslint-disable-next-line no-underscore-dangle
          const _host = window.location.hostname.toString();
          if (!_host.includes('192') && !_host.includes('localhost')) {
            setUserSys(_this.logoUi.appId);
          }
        }
      }
      if (process.env.NODE_ENV !== 'development') {
        prdZnv();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.flyingBook {
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // height: 100%;
  width: 400px;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -60%, 0);

  img {
    display: block;

  }

  div {
    // position: absolute;
    text-align: center;
    font-size: 22px;
    margin-top: 16px;
  }
}
</style>
